<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="cont" title="Contents">
<div class="hide"> </div>
<div class="hide"> </div>
<div class="hide"> </div>
<p class="h2f"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">Contents</span></p>
<p class="tocf0" id="ack"><span class="hide">       </span><a href="#/text/9780253037756_Acknowledgments">Acknowledgments</a></p>
<p class="tocf" id="note"><span class="hide">       </span><a href="#/text/9780253037756_Terms">Note on Terms</a></p>
<p class="tocf" id="abb"><span class="hide">       </span><a href="#/text/9780253037756_Abbreviations">List of Abbreviations</a></p>
<p class="tocfa" id="int"><span class="hide">       </span><a href="#/text/9780253037756_Introduction">Introduction</a></p>
<p class="toc" id="ch1"><span href="#/text/9780253037756_Chapter_1" title="Link target outside of Sample"><b>1</b><span class="space"><span class="hide">     </span>Communities of Victims: Croatian Émigrés and Germans in the 1950s</span></span></p>
<p class="toc" id="ch2"><span href="#/text/9780253037756_Chapter_2" title="Link target outside of Sample"><b>2</b><span class="space"><span class="hide">     </span>History on Trial: Migration, Political Violence, and Memories of World War II</span></span></p>
<p class="toc" id="ch3"><span href="#/text/9780253037756_Chapter_3" title="Link target outside of Sample"><b>3</b><span class="space"><span class="hide">     </span>Second-Class Refugees: The West German–Yugoslav Migration Regime and the Asylum Problem</span></span></p>
<p class="toc" id="ch4"><span href="#/text/9780253037756_Chapter_4" title="Link target outside of Sample"><b>4</b><span class="space"><span class="hide">     </span>Imagining Yugoslavs: From Communist Agents to Ambassadors of Peace</span></span></p>
<p class="toc" id="ch5"><span href="#/text/9780253037756_Chapter_5" title="Link target outside of Sample"><b>5</b><span class="space"><span class="hide">     </span>The Return of the Nation: Bosnian Refugees in the New Germany</span></span></p>
<p class="tocfa" id="epi"><span class="hide">       </span><span href="#/text/9780253037756_Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="tocfa" id="app"><span class="hide">       </span><span href="#/text/9780253037756_Appendix" title="Link target outside of Sample">Appendix</span></p>
<p class="tocf" id="bib"><span class="hide">       </span><span href="#/text/9780253037756_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="tocf" id="ind"><span class="hide">       </span><span href="#/text/9780253037756_Index" title="Link target outside of Sample">Index</span><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253037756_Contents.vue?3f70318c